export default "__VITE_PUBLIC_ASSET__2b355c8b__"